import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const productService = {
  // Get all products
  getAllProducts: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PRODUCTS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get product by ID
  getProductById: async (productId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PRODUCT_BY_ID(productId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new product
  createProduct: async (productData) => {
    try {
      // Prepare the data with proper array formatting
      const preparedData = {
        ...productData,
        dimensions: Array.isArray(productData.dimensions) ? productData.dimensions : [productData.dimensions],
        tags: Array.isArray(productData.tags) ? productData.tags : [productData.tags]
      };

      const response = await axios.post(`${API_BASE_URL}${API_URLS.PRODUCTS}`, preparedData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updateProductQuantity: async (productId, quantityToAdd) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.PRODUCT_UPDATE_QUANTITY(productId)}`, {
        stock_quantity: quantityToAdd
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update product
  updateProduct: async (productId, productData) => {
    try {
      // Prepare the data with proper array formatting
      const preparedData = {
        ...productData,
        dimensions: Array.isArray(productData.dimensions) ? productData.dimensions : [productData.dimensions],
        tags: Array.isArray(productData.tags) ? productData.tags : [productData.tags]
      };

      const response = await axios.put(`${API_BASE_URL}${API_URLS.PRODUCT_BY_ID(productId)}`, preparedData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete product
  deleteProduct: async (productId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.PRODUCT_BY_ID(productId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getActiveProducts: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.ACTIVE_PRODUCTS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update product status
  updateProductStatus: async (productId, isActive) => {
    try {
      const response = await axios.patch(`${API_BASE_URL}${API_URLS.PRODUCT_STATUS(productId)}`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default productService;